<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<!-- 공장 -->
				<sf-select-group
					:label="getMessage_('SWCC000015')"
					:inputValue="plantCd"
					:options="tableDataPlants"
					:onChange="value => onChangeSelect('tableDataPlantCd', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- 테이블타입 -->
				<!-- <sf-select-group
					:label="getMessage_('SWCC000537')"
					:inputValue="tableType"
					:options="tableTypes"
					:onChange="value => onChangeSelect('tableType', value)"
				/> -->
				<!-- 스키마 -->
				<sf-select-group
					:label="getMessage_('SWCC000788')"
					:inputValue="schema"
					:options="allSchemas"
					:onChange="value => onChangeSelect('schema', value)"
				/>
			</el-col>
			<el-col :span="5">
				<!-- Table ID -->
				<sf-input-group
					:label="getMessage_('SWCC000538')"
					:labelSpan="12"
					:inputValue="tableId"
					:onChange="value => onChange('tableId', value)"
					@keyupEnter="search"
				/>
			</el-col>
			<el-col :span="4">
				<!-- 사용여부 -->
				<sf-select-group
					:label="getMessage_('SWCC000891')"
					:inputValue="managed"
					:options="useYnOptions"
					:onChange="value => onChangeSelect('managed', value)"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TableDataManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			//TODO: plantCd 중복
			plantCd: '',
			tableType: '',
			schema: '',
			tableId: '',
			managed: '',
			screen: {}
		};
	},

	created() {
		this.screen = this.screenArray.get(this.scrId);
		this.plantCd = this.user.plantCd;

		this.getPlant_().catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
		this.getUseYnList_().catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
		this.getCommCds_({ commCdType: 'TBL_TYPE', commCdList: 'tableTypes', option: 'All' }).catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
		this.getSchemas_({ plantCd: this.tableDataPlantCd }).catch(error => {
			this.$sf_toast({ type: 'error', message: error.message });
		});
	},

	watch: {
		screen() {
			if (this.screen.defaultPageSize && this.user.plantCd) {
				this.defaultAssign_({
					key: 'groups',
					value: { currentPage: 1, pageUnit: Number(this.screen.defaultPageSize), data: [] }
				})
					.then(() => {
						this.search();
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		},
		langCd() {
			this.getUseYnList_().catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
			this.getCommCds_({ commCdType: 'TBL_TYPE', commCdList: 'tableTypes', option: 'All' }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
			this.search();
		}
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		search() {
			this.$sf_toggleLoading(true);
			this.getTableDataManagementList_({
				plantCd: this.tableDataPlantCd,
				//tableType: this.tableType,
				schema: this.schema,
				tableId: this.tableId,
				managed: this.managed,
				currentPage: 1,
				pageUnit: this.groups.pageUnit
			})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		onChangeSelect(key, value) {
			this[key] = value;
			this.search();
		},

		onChange(key, value) {
			this[key] = value;
		}
	}
};
</script>
<style></style>
